import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { Radio } from 'antd';
// Local deps
import './RFFRadio.scss';


const RadioGroup = Radio.Group;

class RFFInputField extends React.Component {

  static initialState = {
    value: '',
  };
  state = RFFInputField.initialState;

  _OnChange = e => {
    this.props.input.onChange(e.target.value);
  };
  render() {
    const {
      input,
      meta,
      labelCol,
      inputCol,
      errorCol,
      label,
      isRequired,
      options,
      ...otherProps
    } = this.props;

    return (
      <div className="nf-rff-input-field">
        <Row className="nf-rff-input-field__row">
          {/* <!-- LABEL --> */}
          {label && (
            <Col {...labelCol}>
              <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                {label}
                {isRequired && (
                  <span className="nf-rff-input-field__required">*</span>
                )}
              </Label>
            </Col>
          )}

          {/* <!-- INPUT --> */}
          <Col {...inputCol}>
            <RadioGroup onChange={this._OnChange}{...input} {...otherProps}>
              {options.map(option => <Radio key={option.value} value={option.value}>{option.text}</Radio>
              )}
            </RadioGroup>

          </Col>

          {/* <!-- ERROR -> */}
          {meta.touched &&
            meta.error && (
              <Col {...errorCol}>
                <div className="nf-rff-input-field__error">{meta.error}</div>
              </Col>
            )}
        </Row>
      </div>
    );
  }
}

RFFInputField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
};

RFFInputField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
};

export default RFFInputField;



// WEBPACK FOOTER //
// ./src/components/form/RFFRadio/RFFRadio.jsx